import React from 'react';
import { withSiteData, Head } from 'react-static';
import { SITE_TITLE, SITE_TITLE_SUFFIX } from "@flow/utils/constants";
import { ContentGroup, IPage } from "types/IPage";
import { IArtist } from "types/IArtist";
import { INews } from "types/INews";

interface Props {
  options: any;
  page: IPage;
  news: INews;
  artist: IArtist;
}

class SEOTags extends React.Component<Props, {}> {

  render() {
    const {
      page,
      news,
      artist,
    } = this.props;

    let title;
    let is_front_page = false;
    let description;
    let lang_versions;
    let shareImage;

    if (page) {
      title = page.title;
      is_front_page = page.is_front_page;
      lang_versions = page.lang_versions;
      description = this._chooseDescription(page.content_group);
      shareImage = this._chooseImage(page.images);
    } else if (news) {
      title = news.title;
      description = this._chooseDescription(news.content_group);
      lang_versions = news.lang_versions;
    } else if (artist) {
      title = artist.title;
      description = this._chooseDescription(artist.content_group);
      lang_versions = artist.lang_versions;
      shareImage = this._chooseImage(artist.images);
    }

    return (
      <Head>
        {this._renderTitle(title, is_front_page)}
        {this._renderDescription(description)}
        {this._renderHreflangs(lang_versions)}
        {this._renderMetaImage(shareImage)}
      </Head>
    );
  }

  private _chooseDescription = (content_group: ContentGroup) : string | null => {
    if (content_group) {
      if (content_group.short_description) {
        return content_group.short_description;
      } else if (content_group.content) {
        return this._parseDescription(content_group.content);
      }
    }

    return null;
  };

  private _chooseImage = (images: Images) : string | null => {
    if (images) {
      if (images.landscape && images.landscape.length) {
        return images.landscape[0].large;
      } else if (images.portrait && images.portrait.length) {
        return images.portrait[0].large;
      }
    }

    return 'https://www.flowfestival.com/assets/images/fb-share.jpg';
  };

  private _renderMetaImage = (imgUrl: string) : JSX.Element => {
    if (imgUrl) {
      return <meta property="og:image" content={imgUrl} />;
    } else {
      return null;
    }
  };

  private _renderTitle = (title: string, is_front_page: boolean | undefined): JSX.Element[] => {
    if (is_front_page) {
      return [
        <title key={1}>{SITE_TITLE}</title>,
        <meta key={2} property="og:title" content={SITE_TITLE} />,
        <meta key={3} property="og:site_name" content={SITE_TITLE} />,
        <meta key={3} property="og:type" content="website" />,
      ];
    } else {

      const joined_title = `${title}${SITE_TITLE_SUFFIX}`;
      return [
        <title key={1}>{joined_title}</title>,
        <meta key={2} property="og:title" content={joined_title} />,
        <meta key={3} property="og:site_name" content={SITE_TITLE} />,
        <meta key={3} property="og:type" content="website" />,
      ];
    }
  };

  private _renderDescription = (description: string): null | JSX.Element[] => {
    return [
      <meta key={1} name="description" content={description} />,
      <meta key={2} name="twitter:description" content={description} />,
      <meta key={3} property="og:description" content={description} />,
    ];
  };

  private _renderHreflangs = (lang_versions: LangVersions | undefined): JSX.Element[] | null => {
    if (lang_versions) {
      return lang_versions.map((lang_version: LangVersion, idx: number) => {
        if (lang_version.is_translation) {
          return (<link key={idx} rel="alternate" hrefLang={lang_version.lang_code} href={`https://www.flowfestival.com${lang_version.url}`} />);
        }
      });
    } else {
      return null;
    }
  };

  private _parseDescription = (text: string) => {
      const match = text.match(/<p>(.*?)<\/p>/);

      if (match) {
        return match[1];
      } else {
        return null
      }
  }
}

export default withSiteData(SEOTags);


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/seo/SEOTags.tsx